module.exports = __webpack_public_path__ + "public/img/attend.276806cb.png";